export default __webpack_public_path__ + "static/media/Dog.7e45db24.gif";